import { useEffect } from "react";

const SITE = (typeof process !== "undefined" && process.env && process.env.REACT_APP_SITE_URL) || "https://industrialpro.co.in";
const DEFAULT_IMG = "https://images.unsplash.com/photo-1767294274634-613a3545e36d";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Seo — imperatively manages document head for the active route.
 * props: title, description, canonical, image, jsonLd (array of objects), noindex
 */
export default function Seo({ title, description, canonical, image, jsonLd = [], noindex = false }) {
  const jsonLdKey = JSON.stringify(jsonLd);
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex,follow" : "index,follow,max-image-preview:large");
    upsertLink("canonical", canonical || SITE + window.location.pathname);

    // hreflang en-IN self reference
    let hre = document.head.querySelector('link[rel="alternate"][hreflang="en-IN"]');
    if (!hre) {
      hre = document.createElement("link");
      hre.setAttribute("rel", "alternate");
      hre.setAttribute("hreflang", "en-IN");
      document.head.appendChild(hre);
    }
    hre.setAttribute("href", canonical || SITE + window.location.pathname);

    // Open Graph
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "IndustrialPro Automation");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical || SITE + window.location.pathname);
    upsertMeta("property", "og:image", image || DEFAULT_IMG);
    upsertMeta("property", "og:locale", "en_IN");
    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image || DEFAULT_IMG);

    // JSON-LD
    const nodes = [];
    jsonLd.filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "route");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      nodes.push(s);
    });
    return () => nodes.forEach((n) => n.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonical, image, noindex, jsonLdKey]);

  return null;
}
